<template>
  <div>
    <slotBase :bg-grey="true" :footerRadius="true">
      <template v-slot:content>
        <div
          class="main p-a-16"
          style="display: flex; align-items: center; height: 90vh"
        >
          <div class="w-100">
            <div class="card-one d-flex">
              <div
                class="card p-0 shadow"
                style="border-radius: 15px; width: -webkit-fill-available"
              >
                <div class="card-header p-0">
                  <div class="sd-heading">
                    <img
                      src="../../../assets/logo.jpg"
                      alt="Profile Picture"
                      class="profile-pic"
                    />
                  </div>
                </div>
                <div class="sd-body p-a-16">
                  <form>
                    <p class="f-Overpass f-14 f-w-400 m-0">
                      Masukan Nomer Whatsapp Kamu Yang Terdaftar
                    </p>
                    <div class="mb-3 mt-3">
                      <label
                        for="whatsapp"
                        class="f-Overpass f-14 f-w-400 m-0 f-c-grey"
                        >Nomor WhatsApp <span class="spn-2">*</span></label
                      >
                      <div class="input-group">
                        <span
                          class="input-group-text f-16"
                          id="inputGroup-sizing-sm"
                          >62</span
                        >
                        <input
                          type="number"
                          class="form-control f-16 f-Overpass"
                          id="whatsapp"
                          aria-describedby="whatsapp"
                          placeholder="Masukan Nomor"
                          v-model="noTelp"
                          v-on:input="validationInputTelp"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="p-x-24 p-t-16 p-b-16">
          <button
            type="button"
            class="btn btn-primary w-100 f-Overpass"
            style="font-size: 16px; margin-top: 12px"
            @click="loginUser"
          >
            <span
              class="spinner-border text-light f-16 spiner-border-sm"
              v-if="btnLogin"
            ></span>
            <span v-if="!btnLogin">Kirim Kode OTP</span>
          </button>
        </div>
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "loginApp",
  components: {
    slotBase,
  },
  data() {
    return {
      noTelp: "",
      btnLogin: false,
    };
  },

  computed: {
    ...mapState("auth", {
      dataOtpForgotAuth: "dataOtpForgotAuth",
    }),
  },

  methods: {
    ...mapActions({
      otpForgot: "auth/postRequestOtpForgot",
    }),

    validationInputTelp() {
      this.noTelp = this.noTelp.replace(/[^0-9]/g, "");

      const invalidChar = /e-{;'.,|=};.'/;
      if (invalidChar.test(this.noTelp)) {
        this.noTelp = this.noTelp.replace(invalidChar, "");
        return;
      }

      if (this.noTelp.startsWith("62") || this.noTelp.startsWith("0")) {
        this.noTelp = "";
        return;
      }
    },

    async loginUser() {
      this.btnLogin = true;
      if (this.noTelp !== "") {
        let data = {
          telp: this.noTelp,
          country_code: "62",
        };
        this.$store.commit("auth/requestDataOtpForgot", data);

        await this.otpForgot(data).then((res) => {
          if (res.data.status != 200) {
            this.btnLogin = false;
            this.$toast.error(res.data.message, { position: "top" });
          }
          if (res.data.status == 200) {
            this.$toast.success(res.data.message, { position: "top" });
            this.$router.push({
              name: "forgotPasswordOtp",
              params: { noTelp: this.noTelp },
            });
          }
        });
      } else {
        this.btnLogin = false;
        this.$toast.error("Field masih kosong", { position: "top" });
      }
    },
  },
};
</script>

<style scoped>
.card-one {
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  align-items: center;
  width: -webkit-fill-available;
}

.profile-pic {
  width: 110px; /* Set the width and height of the circular image */
  height: 110px;
  border-radius: 70%; /* Create a circular shape */
  position: absolute; /* Position the image absolutely */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 1%;
  left: 50%; /* Position horizontally at the center */
  transform: translate(-50%, -50%);
}

.sd-heading {
  background-color: #206cfe;
  height: 70px;
  color: #fff;
  align-self: stretch;
  border-radius: 16px 16px 0px 0px;
  background: var(--primary-product-smartlink, #206cfe);
}

.spn-2 {
  color: #007bff;
}

.button-eye {
  transform: translateY(30%);
  position: absolute;
  right: 0;
  padding-right: 30px;
}
</style>
